import { useQuery } from "@tanstack/react-query";
import { listReviewSummaries } from "@/lib/reviews.functions";

export type CardRating = { count: number; average: number };

/**
 * Φορτώνει μία φορά (και κρατά στην cache) τη σύνοψη των εγκεκριμένων
 * αξιολογήσεων για όλα τα προϊόντα, ώστε οι κάρτες προϊόντων να δείχνουν
 * αστέρια χωρίς ξεχωριστό request ανά κάρτα.
 */
export function useReviewSummaries(): Map<string, CardRating> {
  const { data } = useQuery({
    queryKey: ["review-summaries"],
    queryFn: () => listReviewSummaries(),
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
  const map = new Map<string, CardRating>();
  for (const it of data?.items ?? []) {
    map.set(it.productId, { count: it.count, average: it.average });
  }
  return map;
}

/** Σύνοψη αξιολόγησης για ένα προϊόν. */
export function useProductRating(productId: string | null | undefined): CardRating | undefined {
  const map = useReviewSummaries();
  return productId ? map.get(productId) : undefined;
}
